import { CashFlowPaymentTypeEnum } from '@/services/api-clients';

export function cashFlowPaymentTypeColorFilter(paymentType: CashFlowPaymentTypeEnum) {
  switch (paymentType) {
    case CashFlowPaymentTypeEnum.Cash: return 'success';
    case CashFlowPaymentTypeEnum.Transfer: return 'primary';
    case CashFlowPaymentTypeEnum.AdvancePaymentCash: return 'deep-purple';
    case CashFlowPaymentTypeEnum.AdvancePaymentTransfer: return 'warning';
    default: return '';
  }
}
